import styled, { css } from 'styled-components';
var Text = styled.div.withConfig({
  displayName: "StyledText__Text",
  componentId: "bke95e-0"
})(["font-family:", ";text-align:", ";color:", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (_ref2) {
  var align = _ref2.align;
  return align;
}, function (_ref3) {
  var theme = _ref3.theme,
    color = _ref3.color;
  return theme.colors[color] ? theme.colors[color] : color;
}, function (_ref4) {
  var italic = _ref4.italic;
  return italic && css(["font-style:italic;"]);
}, function (_ref5) {
  var gradientText = _ref5.gradientText,
    color = _ref5.color;
  return gradientText && css(["background-image:linear-gradient(180deg,", " 12.15%,#ffffff 100%);color:transparent;-webkit-background-clip:text;"], color);
});
var HXSText = styled(Text).withConfig({
  displayName: "StyledText__HXSText",
  componentId: "bke95e-1"
})(["font-weight:", ";font-size:16px;line-height:23px;letter-spacing:-0.3px;"], function (_ref6) {
  var weight = _ref6.weight;
  return weight || '600';
});
var HSMText = styled(Text).withConfig({
  displayName: "StyledText__HSMText",
  componentId: "bke95e-2"
})(["font-weight:", ";font-size:18px;line-height:24px;letter-spacing:-0.3px;"], function (_ref7) {
  var weight = _ref7.weight;
  return weight || '600';
});
var HMDText = styled(Text).withConfig({
  displayName: "StyledText__HMDText",
  componentId: "bke95e-3"
})(["font-weight:", ";font-size:21px;line-height:29px;letter-spacing:-0.4px;"], function (_ref8) {
  var weight = _ref8.weight;
  return weight || '500';
});
var HLGText = styled(Text).withConfig({
  displayName: "StyledText__HLGText",
  componentId: "bke95e-4"
})(["font-weight:", ";font-size:24px;line-height:31px;letter-spacing:-0.5px;"], function (_ref9) {
  var weight = _ref9.weight;
  return weight || '500';
});
var HXLText = styled(Text).withConfig({
  displayName: "StyledText__HXLText",
  componentId: "bke95e-5"
})(["font-weight:", ";font-size:30px;line-height:35px;letter-spacing:-0.8px;"], function (_ref10) {
  var weight = _ref10.weight;
  return weight || '500';
});
var HXXLText = styled(Text).withConfig({
  displayName: "StyledText__HXXLText",
  componentId: "bke95e-6"
})(["font-weight:", ";font-size:34px;line-height:40px;letter-spacing:-1.3px;"], function (_ref11) {
  var weight = _ref11.weight;
  return weight || '500';
});
var SSMText = styled(Text).withConfig({
  displayName: "StyledText__SSMText",
  componentId: "bke95e-7"
})(["font-weight:", ";font-size:12px;line-height:18px;letter-spacing:-0.1px;"], function (_ref12) {
  var weight = _ref12.weight;
  return weight || '600';
});
var SMDText = styled(Text).withConfig({
  displayName: "StyledText__SMDText",
  componentId: "bke95e-8"
})(["font-weight:", ";font-size:14px;line-height:20px;letter-spacing:-0.2px;"], function (_ref13) {
  var weight = _ref13.weight;
  return weight || '600';
});
var SLGText = styled(Text).withConfig({
  displayName: "StyledText__SLGText",
  componentId: "bke95e-9"
})(["font-weight:", ";font-size:14px;line-height:24px;letter-spacing:-0.2px;"], function (_ref14) {
  var weight = _ref14.weight;
  return weight || '600';
});
var LSMText = styled(Text).withConfig({
  displayName: "StyledText__LSMText",
  componentId: "bke95e-10"
})(["font-weight:", ";font-size:12px;line-height:18px;letter-spacing:-0.1px;"], function (_ref15) {
  var weight = _ref15.weight;
  return weight || '500';
});
var LMDText = styled(Text).withConfig({
  displayName: "StyledText__LMDText",
  componentId: "bke95e-11"
})(["font-weight:", ";font-size:14px;line-height:20px;letter-spacing:-0.2px;"], function (_ref16) {
  var weight = _ref16.weight;
  return weight || '500';
});
var LLGText = styled(Text).withConfig({
  displayName: "StyledText__LLGText",
  componentId: "bke95e-12"
})(["font-weight:", ";font-size:14px;line-height:24px;letter-spacing:-0.2px;"], function (_ref17) {
  var weight = _ref17.weight;
  return weight || '500';
});
var BSMText = styled(Text).withConfig({
  displayName: "StyledText__BSMText",
  componentId: "bke95e-13"
})(["font-weight:", ";font-size:12px;line-height:18px;letter-spacing:0px;"], function (_ref18) {
  var weight = _ref18.weight;
  return weight || '400';
});
var BMDText = styled(Text).withConfig({
  displayName: "StyledText__BMDText",
  componentId: "bke95e-14"
})(["font-weight:", ";font-size:14px;line-height:20px;letter-spacing:0.1px;"], function (_ref19) {
  var weight = _ref19.weight;
  return weight || '400';
});
var BLGText = styled(Text).withConfig({
  displayName: "StyledText__BLGText",
  componentId: "bke95e-15"
})(["font-weight:", ";font-size:14px;line-height:24px;letter-spacing:0.1px;"], function (_ref20) {
  var weight = _ref20.weight;
  return weight || '400';
});
var NMDText = styled(Text).withConfig({
  displayName: "StyledText__NMDText",
  componentId: "bke95e-16"
})(["font-weight:", ";font-size:14px;line-height:16px;letter-spacing:0.2px;"], function (_ref21) {
  var weight = _ref21.weight;
  return weight || '500';
});
var NLGText = styled(Text).withConfig({
  displayName: "StyledText__NLGText",
  componentId: "bke95e-17"
})(["font-weight:", ";font-size:16px;line-height:24px;letter-spacing:0px;"], function (_ref22) {
  var weight = _ref22.weight;
  return weight || '500';
});
var NXLText = styled(Text).withConfig({
  displayName: "StyledText__NXLText",
  componentId: "bke95e-18"
})(["font-weight:", ";font-size:21px;line-height:28px;letter-spacing:-0.8px;"], function (_ref23) {
  var weight = _ref23.weight;
  return weight || '400';
});
var NXXLText = styled(Text).withConfig({
  displayName: "StyledText__NXXLText",
  componentId: "bke95e-19"
})(["font-weight:", ";font-size:34px;line-height:38px;letter-spacing:-0.8px;"], function (_ref24) {
  var weight = _ref24.weight;
  return weight || '400';
});
export { HXSText, HSMText, HMDText, HLGText, HXLText, HXXLText, SSMText, SMDText, SLGText, LSMText, LMDText, LLGText, BSMText, BMDText, BLGText, NMDText, NLGText, NXLText, NXXLText };